import { xhr } from '@/xhr/endpoints';
import { getId } from '@/assets/js/utils';
import { EventBus } from '@/assets/js/event-bus';
//
// state
const state = {
  userAzureID: '',
  userData: null,
  invitations: null,
  notifications: null,
  teamLeadAccess: {},

  /** LEGACY... */
  user: {
    id: 1,
    name: 'Alexander Pope',
    imageType: 'jpg',
    documentsList: [],
  },
};

//
// getters
const getters = {
  userId: state => getId(state.userData),
  invitationsCount: state => (state.invitations ? ` (${state.invitations.length})` : ''),
  notification_count: state => (state.notifications ? state.notifications.notification_count : ''),
};

//
// mutations
const mutations = {
  setUserAzureID(state, userAzureID) {
    state.userAzureID = userAzureID;
  },
  setInvitations(state, invitations) {
    state.invitations = invitations;
  },
  setTeamLeadAccess(state, teamLeadAccess) {
    state.teamLeadAccess = teamLeadAccess;
  },
  setNotifications(state, notifications) {
    state.notifications = notifications;
  },
  setUserData(state, data) {
    state.userData = data;
  },
};

//
// actions
const actions = {
  loadMyAccount: async ({ commit, dispatch }) => {
    try {
      let userData = await xhr.loadMyAccount();
      commit('setUserData', userData);
      await dispatch('getTeamLeadAccess');
      return userData;
    } catch (err) {
      console.error(err);
      commit('setIdToken', null);
    }
  },

  loadMyContacts: async (context, { sortColumn, sortDirection, filters }) => {
    try {
      let userContacts = await xhr.loadMyContacts(sortColumn, sortDirection, filters);
      return userContacts;
    } catch (err) {
      console.error(err);
    }
  },

  addMyContacts: async (context, contacts) => {
    try {
      let res = await xhr.addMyContacts(contacts);
      return res;
    } catch (err) {
      alert('New contact not created; a contact with that email address already exists');
      return false;
    }
  },

  updateContact: async (context, contact) => {
    try {
      await xhr.updateContact(contact);
      return true;
    } catch (err) {
      alert('a contact with that email address already exists');
      return false;
    }
  },

  updateUserDocument: async (context, { documentId, archive }) => {
    try {
      await xhr.updateUserDocument(documentId, archive);
      return true;
    } catch (err) {
      return false;
    }
  },
  updateUserInvitation: async (context, { invitationId, archive }) => {
    try {
      await xhr.updateUserInvitation(invitationId, archive);
      return true;
    } catch (err) {
      return false;
    }
  },

  loadMyTeams: async (context, { sortColumn, sortDirection, filters }) => {
    try {
      let userTeams = await xhr.loadMyTeams(sortColumn, sortDirection, filters);
      return userTeams;
    } catch (err) {
      console.error(err);
    }
  },

  addMyTeam: async (context, team) => {
    try {
      await xhr.addMyTeam(team);
      return true;
    } catch (err) {
      return false;
    }
  },

  createNewUserAccount: (context, name, email) => {
    xhr.createDocument({
      azID: '000',
      name: name,
      email: email,
      account: {
        accountNumber: '000',
        accountType: 'Paid',
        purchased: true,
      },
    });
  },
  loadUserDocuments: async (
    { state, commit },
    { page, resultsPerPage, sortColumn, sortDirection, filters }
  ) => {
    let documents = await xhr.getUserDocuments(
      page,
      resultsPerPage,
      sortColumn,
      sortDirection,
      filters
    );
    //
    // if a document was created on a different tab or browser before a reload, add it to the global user documents list (bug 661)
    const newDocuments = documents.results.filter(
      doc => !state.userData.documents?.some(userDoc => userDoc._id == doc._id)
    );
    if (newDocuments.length)
      commit('setUserData', {
        ...state.userData,
        documents: state.userData.documents
          ? [...state.userData.documents, ...newDocuments]
          : newDocuments,
      });
    return documents;
  },
  loadUserInvitations: async (context, params = {}) => {
    try {
      const { page, resultsPerPage, sortColumn, sortDirection, filters } = params;
      let invitations = await xhr.getUserPendingInvitations(
        page,
        resultsPerPage,
        sortColumn,
        sortDirection,
        filters
      );
      return invitations || { results: [], totalCount: 0 };
    } catch (error) {
      console.error('Error loading user invitations:', error);
      return { results: [], totalCount: 0 };
    }
  },
  getNotifications: async ({ commit, getters }) => {
    try {
      if (!getters.isMobileScreenSize) {
        let notifications = await xhr.getNotifications();
        commit('setNotifications', notifications);
        EventBus.emit('set.notification.count', notifications);
        return notifications;
      }
    } catch (err) {
      console.error(err);
    }
  },
  getTeamLeadAccess: async ({ state, commit }) => {
    if (!state.publicView) {
      try {
        let teamAccess = await xhr.getTeamLeadAccess();
        commit('setTeamLeadAccess', teamAccess);
        return teamAccess;
      } catch (err) {
        console.error(err);
      }
    }
  },
};

//
// exports
export default {
  // namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
